import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { ADMIN_USERS_API_PATHS } from '../constants/users-paths.constants';

type UseSendEcoWelcomeEmailResult = {
  sendEcoWelcomeEmail: (userId: string) => Promise<boolean>;
  isSubmitting: boolean;
};

export function useSendEcoWelcomeEmail(): UseSendEcoWelcomeEmailResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const sendEcoWelcomeEmail = async (userId: string): Promise<boolean> => {
    setIsSubmitting(true);

    try {
      await HttpClient.post<{ sentAt: string }>(ADMIN_USERS_API_PATHS.SEND_ECO_WELCOME(userId));

      enqueueSnackbar('Mail de bienvenue envoyé', { variant: 'success' });
      return true;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de l'envoi du mail de bienvenue"),
        { variant: 'error' }
      );
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { sendEcoWelcomeEmail, isSubmitting };
}
